module.exports = __webpack_public_path__ + "media/images/coachcatalyst_long 1-adb8876f.png";